module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_07.ddf6de07.png";